import produce from 'immer';
import { StepPrecheckAction } from '../../../actions/workflows/steps/Precheck';
import * as Constants from '../../../constants/action-constants';
import initialState from '../../../InitialState';
import { PrecheckStep } from '../../../types/workflows/steps/Precheck';

const precheckStep = (
  state: PrecheckStep = initialState.environmentWorkflow.steps.precheck,
  action: StepPrecheckAction
): PrecheckStep => {
  return produce<PrecheckStep, PrecheckStep>(state, draft => {
    switch (action.type) {
      case Constants.INITIALIZE_STEP_PRECHECK: {
        draft.fetching = true;
        draft.failed = false;
        break;
      }
      case Constants.INITIALIZE_STEP_PRECHECK_FAILED: {
        draft.fetching = false;
        draft.failed = true;
        break;
      }
      case Constants.INITIALIZE_STEP_PRECHECK_SUCCESS: {
        Object.assign(draft, {
          fetching: false,
          failed: false,
          ...action.payload
        });
        break;
      }
    }
  });
};

export default precheckStep;
